import React from 'react';
import {
    Dialog,
    DialogContent,
    DialogHeader,
    DialogTitle,
    DialogDescription,
    DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Info } from 'lucide-react';

interface SiteUpdateModalProps {
    isOpen: boolean;
    onClose: () => void;
    title: string;
    content: string;
}

const SiteUpdateModal: React.FC<SiteUpdateModalProps> = ({ isOpen, onClose, title, content }) => {
    return (
        <Dialog open={isOpen} onOpenChange={onClose}>
            <DialogContent className="bg-card text-card-foreground">
                <DialogHeader>
                    <DialogTitle className="flex items-center gap-2 text-primary"><Info /> {title}</DialogTitle>
                </DialogHeader>
                <div className="prose prose-invert max-w-none" dangerouslySetInnerHTML={{ __html: content }} />
                <DialogFooter>
                    <Button onClick={onClose}>Bezárás</Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};

export default SiteUpdateModal;